var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Widget } from "./angular2-schema-form-shim";
var WidgetTooltip = (function () {
    function WidgetTooltip() {
        this._visible = false;
    }
    Object.defineProperty(WidgetTooltip.prototype, "self", {
        get: function () {
            return this.constructor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WidgetTooltip.prototype, "widgetHasTooltip", {
        get: function () {
            return !!(this.tooltip && this.tooltip.body);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WidgetTooltip.prototype, "help", {
        get: function () {
            return this.widget.schema.help || {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WidgetTooltip.prototype, "tooltip", {
        get: function () {
            var help = this.help;
            return __assign({ title: null, body: typeof help.tooltip === 'string' ? help.tooltip : null }, (typeof help.tooltip === 'object' ? help.tooltip : null));
        },
        enumerable: true,
        configurable: true
    });
    WidgetTooltip.prototype.show = function () {
        this.visible = true;
    };
    WidgetTooltip.prototype.hide = function () {
        this.visible = false;
    };
    Object.defineProperty(WidgetTooltip.prototype, "visible", {
        get: function () {
            return this._visible;
        },
        set: function (newState) {
            this.hideAll();
            this.self.currentTooltip = this;
            this._visible = newState;
        },
        enumerable: true,
        configurable: true
    });
    WidgetTooltip.prototype.hideAll = function () {
        if (this.self.currentTooltip && this.self.currentTooltip != this) {
            this.self.currentTooltip.hide();
            this.self.currentTooltip = null;
        }
    };
    WidgetTooltip.prototype.toggle = function ($event) {
        $event.preventDefault();
        this.visible = !this.visible;
    };
    WidgetTooltip.currentTooltip = null;
    return WidgetTooltip;
}());
export { WidgetTooltip };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/tooltip.component.ts.pre-build-optimizer.js